<script setup lang="ts">
/**
 * @author Beka Chkhaidze
 */
import { onBeforeMount, computed } from "vue";
import { useMainStore } from "@/store/main/index";
import { useBuildingStore } from "@/store/building";
import type { SecondaryDataInterface } from "@/types/ContentType";

import { isInView } from "@/composables/utils/isInView";
import { getWidgetSS, getTaxonomySS } from "@/composables/core/func";

import Borders from "@/components/regularComponents/UIComponents/Borders.vue";
import LeaveMessage from "./parts/LeaveMessage.vue";
import Meeting from "./parts/Meeting.vue";
import WhoWeAre from "./parts/WhoWeAre.vue";

defineProps<{
  contentData?: SecondaryDataInterface;
}>();

const mainStore = useMainStore();
const buildingStore = useBuildingStore();

await getWidgetSS(["contact-us-images"]);

await getTaxonomySS("project_status");

const firstTrigger: Ref<boolean> = ref(false);
const secondTrigger: Ref<boolean> = ref(false);
const imageTop = ref();
const imageBottom = ref();

const images = computed(() => mainStore.widgets?.["contact-us-images"]);

onMounted(() => {
  setTimeout(() => {
    window?.addEventListener("scroll", () => {
      firstTrigger.value = isInView(imageTop.value!, 1);
      secondTrigger.value = isInView(imageBottom.value!, 1);
    });
  }, 500);
});

onBeforeMount(async () => {
  if (!buildingStore.projectList?.length) {
    await buildingStore.getProjects({
      forceRefetch: true,
      params: {
        limit: 100,
      },
    });
  }
});
</script>

<template>
  <section class="contact-us text-center">
    <Borders :count="4" />
    <div class="container pos-rel">
      <h1 class="contact-us__intro uppercase">
        {{ contentData?.conf?.header?.title }}
      </h1>

      <template v-if="images">
        <div
          ref="imageTop"
          class="contact-us__banner-top"
          :style="`--url: url(${images?.top?.[0].devices?.desktop})`"
          :class="firstTrigger ? 'is-inview' : ''"
        />
        <div
          ref="imageBottom"
          class="contact-us__banner-bottom"
          :style="`--url: url(${images?.bottom?.[0].devices?.desktop})`"
          :class="secondTrigger ? 'is-inview' : ''"
        />
      </template>

      <WhoWeAre />
      <LeaveMessage />
      <Meeting />
    </div>
  </section>
</template>

<style lang="scss" src="./styles/contactUs.scss" />
